import { FC, ReactNode } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { WhitePaper } from 'common/WhitePaper/WhitePaper'

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    height: '100%'
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: '5%'
  },
  reportValue: {
    fontSize: 30,
    fontWeight: 600,
    marginTop: '5%'
  },
  reportIcon: {
    width: '22%',
    height: '100%'
  }
}))

type SimpleReportProps = {
  title: ReactNode
  reportIcon: ReactNode,
  reportValue: undefined | number
}
export const SimpleReport: FC<SimpleReportProps> = ({
  title,
  reportIcon,
  reportValue
}) => {
  const classes = useStyles()
  return (
    <WhitePaper container item className={classes.wrapper}>
      <Grid container item>
        <Grid item className={classes.reportIcon}>{reportIcon}</Grid>
      </Grid>
      <Grid container item>
        <Grid item className={classes.title}>{title}</Grid>
      </Grid>
      <Grid container item>
        <Grid item className={classes.reportValue}>{reportValue}</Grid>
      </Grid>
    </WhitePaper>
  )
}
